{
  "nav": {
    "home": "Home",
    "scouting": "Scouting",
    "reports": "Reports",
    "settings": "Settings"
  },
  "settings": {
    "language": "Language",
    "languageDescription": "Choose the language used across the app.",
    "save": "Save"
  },
  "reports": {
    "title": "Scout Reports",
    "empty": "No reports yet",
    "generateSummary": "Generate summary",
    "translationUnavailable": "Translation unavailable. Showing the original report.",
    "retryTranslation": "Try again",
    "matchesHeading_one": "Match:",
    "matchesHeading_other": "Matches:",
    "matchLineHome": "vs {{opponent}} on {{date}}",
    "matchLineAway": "@ {{opponent}} on {{date}}",
    "matchLineNeutral": "{{opponent}} on {{date}}",
    "editorTitle": "Edit Scout Report",
    "untitled": "Report",
    "authorSelf": "You",
    "sharedBadge": "Shared",
    "shareAction": "Share",
    "sharedAction": "Shared",
    "back": "Back",
    "editedBy": "Edited by",
    "createdBy": "Created by",
    "translate": "Translate",
    "translating": "Translating...",
    "showOriginal": "Show Original",
    "download": "Download",
    "downloading": "Downloading...",
    "edit": "Edit",
    "archive": "Archive"
  },
  "language": {
    "control": "Language",
    "selectTitle": "Select Language",
    "change": "Change language",
    "changeCurrent": "Change language, currently {{language}}",
    "changeStranded": "Change language. Your saved language {{code}} is no longer offered, so {{language}} is used instead.",
    "generate": "Generate · {{language}}",
    "generateAccessibility": "Generate summary language",
    "saveDefault": {
      "idle": "Save as my default language",
      "saving": "Saving…",
      "saved": "Saved as your default language",
      "alreadyDefault": "This is already your default language",
      "error": "Couldn't save — tap to try again",
      "warning": "Applies to this summary only. Save it as your default, or you'll need to generate it again next time.",
      "errorAccessible": "{{label}}. {{reason}}",
      "failed": "Couldn't save your default language. Please try again."
    }
  }
}
